import {
  Alert,
  Button,
  Col,
  Divider,
  Form,
  Input,
  Modal,
  notification,
  Row,
} from "antd";
import { useTranslation } from "react-i18next";

import { useAddTreuhandstelleMutation } from "store/masterdata";
import { AddTHsParams, FindTreuhandstelleParams } from "types/masterdata.types";

interface Props {
  kundennummer: number;
  visible: boolean;
  onClose(): void;
  onSuccess(values: FindTreuhandstelleParams): void;
}

function CreateNewTHsForm({
  kundennummer,
  visible,
  onClose,
  onSuccess,
}: Props): JSX.Element {
  const { t } = useTranslation();
  const [tHsForm] = Form.useForm();

  const [addTHs, addTHsResult] = useAddTreuhandstelleMutation();

  const handleTHFormSubmit = async (values: AddTHsParams) => {
    try {
      const repsonse = await addTHs({ ...values, kundennummer }).unwrap();
      if (!repsonse?.hasErrors) {
        notification.success({
          message: t("masterdata.lw_details.add_ths_success"),
        });
        onSuccess({
          name: values.name || "",
          address: values.address || "",
          place: values.place || "",
          postalCode: values.postalCode || "",
        });
        onClose();
      }
    } catch (e) {
      console.log(e);
    }
  };

  return (
    <Modal
      footer={null}
      title={t("masterdata.lw_details.create_new_ths")}
      visible={visible}
      onCancel={onClose}
      destroyOnClose
    >
      <Form
        id="ths-form"
        form={tHsForm}
        onFinish={handleTHFormSubmit}
        layout="vertical"
        initialValues={{
          name: "",
          address: "",
          place: "",
          postalCode: "",
        }}
      >
        {addTHsResult.data?.hasErrors && (
          <>
            <Alert
              message={addTHsResult.data?.errorDetails.errorMessage}
              type="error"
            />
            <Divider />
          </>
        )}
        <Form.Item label="Firma" name="name" rules={[{ required: true }]}>
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.adresse")}
          name="address"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.postal_code")}
          name="postalCode"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label={t("masterdata.lw_details.ort")}
          name="place"
          rules={[{ required: true }]}
        >
          <Input />
        </Form.Item>

        <Row gutter={20}>
          <Col span={12}>
            <Button onClick={onClose} block>
              {t("discard")}
            </Button>
          </Col>
          <Col span={12}>
            <Button
              type="primary"
              htmlType="submit"
              loading={addTHsResult.isLoading}
              block
            >
              {t("save_changes")}
            </Button>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
}

export default CreateNewTHsForm;
